import { REGEX } from '@/constants/regex';
import SVTextInput from './SVTextInput';
import { useFormContext } from 'react-hook-form';

type SVEmailInputProps = {
  label: string;
  name: string;
  validateMatch?: string;
  disabled?: boolean;
};

export default function SVEmailInput({
  name,
  label,
  validateMatch,
  disabled,
}: SVEmailInputProps) {
  const formMethods = useFormContext();
  const matchValue = validateMatch ? formMethods.watch(validateMatch) : '';

  return (
    <SVTextInput
      name={name}
      label={label}
      rules={{
        required: true,
        pattern: {
          regex: REGEX.EMAIL,
          readablePatternName: 'email',
        },
        validate: validateMatch
          ? (value: string) => {
              return value === matchValue || 'Emails must match';
            }
          : undefined,
      }}
      disabled={disabled}
    />
  );
}
